import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getProductsCsv = async (callback: CallbackObject<void>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'text/csv',
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/catalog/products/csv`, config);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'products.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
